// components/MemoryFeed.jsx — Anamoria SPA
// v2.47 — NEW-163 Increment B (2026-10-30): RESPONSE CARD on the leader's feed (Shared tab + To review).
//   A member's memory that answers the leader's note (row carries groupNoteId — anamoria-memories v2.38)
//   renders the GroupMemoryCard header + pill at the top of its existing card: via the new `headerSlot`
//   prop on VoiceCard v2.16 / VideoCard v1.11, inline for the photo and text cards. Rule:
//   isResponseCard(memory, spaceIsGroup) — groupNoteId && spaceIsGroup; the leader's own entries never
//   carry groupNoteId (the owner create rejects it). New props groupNotes + leaderName (pill only).
//   NEW-164 SUPERSEDED: the footer MediaTypeChip (v2.45) is removed from the inline photo/text footers
//   here and from VoiceCard/VideoCard/MomentCard; the chip now lives only in the response-card header.
//   Non-group spaces were already chip-free → byte-identical. Spec v0.2 §4, §7.
// v2.46 — NEW-162 (2026-10-29): optional `topSlot` prop rendered at the top of feedPad, under the sticky
//   tabs and above the empty state / masonry — on the Shared tab only (Sophie, live render). SpacePage passes the GroupNoteBanner here for group spaces.
//   Absent => byte-identical.
// v2.45 — NEW-164 (2026-10-25): group-feed media-type chip. In GROUP spaces only (gated on
//   spaceIsGroup), each feed card footer shows a MediaTypeChip (Voice/Video/Photo/Note) beside
//   the existing date; VoiceCard/VideoCard receive spaceIsGroup to render it. Presentational.
// v2.44 -- UI cleanup (2026-10-14): true-empty state trimmed. Dropped the redundant
//   "This is {name}'s space." heading (duped the hero "A space for {name}.") and the
//   duplicate "Add a memory" ghost button (hero already has one). Replaced with one gentle
//   descriptive line: "A memory can be a photo, something written, a recording, or simply a
//   day that matters." (brand-voice approved; same copy for personal + group). Copy-only;
//   possessive() no longer used here (still exported + unit-tested in momentTitle); spaceName
//   prop retained but currently unused in the empty state.
// v2.43 -- Option B fix (shared->private vanish): Private tab now uses expandPrivateEntries so a
//   PRIVATE piece inside a SHARED moment container is surfaced instead of disappearing. Private
//   moment containers + standalone private memories unchanged. Frontend-only; momentPieces.js v0.5.
// v2.42 — Feed video-refresh (2026-09-28): the memories fetch previously ran once on mount
//   (or served instantly from the 50-minute memoriesCache — D-4/6B above) and never again, so
//   a video's thumbnail could stay on its loading skeleton indefinitely once postprocess
//   finished. Adds a focus/visibility refetch and a bounded, backing-off poll
//   (isVideoPendingOwner, POLL_SCHEDULE_MS, POLL_CAP_MS above), but — unlike the equivalent
//   contributor-side change — BOTH are gated to only fire when the currently-known memories
//   actually contain a pending video, and both bypass-then-refresh the cache rather than
//   ignore it, so an ordinary feed view with nothing processing is completely unaffected: the
//   50-minute cache's instant-render behavior is unchanged. No backend change — reuses the
//   existing /spaces/:id/memories and /spaces/:id/feed routes. Plan:
//   Anamoria_ContributorFeed_VideoRefresh_BUILD_Plan_v0.2.md.
// v2.41 — NEW-105 (2026-09-26): formatCardAttribution prefers the moment day (memory.dayText) over the upload date on expanded piece cards.
// v2.40 — T-5 (2026-09-13): data-tour="feed-tabs" on the tab row for the onboarding tour
//   (inert; zero runtime cost). No logic/CSS change.
// v2.39 — NEW-95 (2026-09-13): feed tabs mobile overflow — the tab row is a scrollable
//   strip (CSS: .feedV2 .tabs safe-center + overflow-x). A ResizeObserver toggles
//   data-overflowing on the row so CSS shows a right-edge fade only when it overflows.
//   No behaviour/logic change to tabs, feed, fetch, or navigation.
// v2.38 — NEW-66: a member cannot edit/favorite a contributor's memory from the feed.
//   The edit-pencil + favorite-heart overlay is gated to non-contributor cards
//   (creatorType !== 'contributor'); handleEdit no-ops for a contributor memory and
//   handleCardClick opens it read-only (never the RecordPage/VideoPage editors). Server
//   already 404s the mutation (anamoria-memories v2.29); this removes the misleading
//   affordance. Owner cards + leader review/share links unchanged. (2026-09-04)
// v2.37 — Phase 2: show the waiting-to-review count on the "To review" tab (NEW prop
//   pendingReviewCount, from space.pendingReviewCount). Badge only when reviewTabEnabled && count>0. (Sept 3, 2026)
// v2.36 — Gate the "To review" tab to GROUP spaces (Sept 1, 2026): NEW prop spaceIsGroup
//   (backend spaces.is_group_space); reviewTabEnabled = groupSpacesEnabled && spaceIsGroup
//   drives the tab button, subtab bar and review empty-state. A 'pending' deep-link into a
//   non-group space resets to 'private'. Frontend-only; flag-off still byte-identical.
// v2.35 -- DF-7 PR2a: the 3 review-action links (Ask to share / Share with the group /
//   approve) #838B70-token @0.82rem -> terracotta var(--moment-accent) (7.4:1 AA; small
//   text off the brand fill per the brand-token rule). Pending-view PILLS unchanged (deferred).
// v2.34 -- DF-7: brand action-token -- the inline #838B70 uses (share links +
//   pending pills) repointed to var(--moment-action-brand); byte-identical, no
//   visual change. Member-only; contributor feed untouched.
// v2.33 — DF-7 feed chrome: favorited heart glyph 16px -> 20px (HeartIcon filled+outline);
//   reads clearly as a heart. Member-only (contributor feed renders no heart).
// v2.32 — NEW-3/NEW-8 copy pass (locked spec NEW3-NEW8-Copy-For-Review-v0.3): "Just with you"
//   subtab strings updated to the thanatologist/Sophie-approved wording — "Ask to share this" →
//   "Ask to share with group" (#1); "Waiting to hear back" → "Waiting for {creatorName}" with the
//   old string as null fallback (#2); "Kept private" → "Kept between us" (#3); "✓ Shared before" →
//   "Shared before", checkmark dropped (#4). "Remove from group" (#5) already correct. Copy-only,
//   no logic; dark behind group_spaces_enabled. Enablement (flag flip + canary) is a later step.
// v2.31 — Fix 'unshare' optimistic update: also set sharedBefore: true immediately so the
//   "✓ Shared before" checkmark appears in "Just with you" without needing a reload (consistent
//   with the card image which already renders from local state). Rollback restores prevSharedBefore.
//   SPA-only follow-on to v2.30.
// v2.30 — Fix handleReview optimistic update for 'unshare' and 'reject' (two disappear bugs):
//   1. 'unshare' (Remove from group): optimistic update now also sets visibilityPref ->
//      'owner_contributor_only' so the card immediately leaves the Shared tab (expandSharedEntries
//      isLeaderOnlyContribPiece check) and surfaces in "Just with you" without a page reload.
//      Rollback also restores prevVisibilityPref.
//   2. 'reject' (Set aside): auto-switches pendingView to 'rejected' so the set-aside memory
//      stays visible instead of vanishing (user previously had to switch tabs manually).
//   3. All review actions: invalidateMemoriesCache(spaceId) after success so a return-navigation
//      (remount + cache hit) sees the post-review state, not a stale 50-min snapshot.
//   SPA-only; no backend or schema changes.
// v2.29 — NEW-19: "Just with you" card now checks shareDeclined before rendering "Ask to share this".
//   If shareDeclined=true and shareRequested=false (asked + declined), shows muted "Kept private" label
//   instead, so the leader cannot re-ask via the UI even though Endpoint A's ask-once guard would also
//   silently reject it. Dark (requires shareDeclined from anamoria-memories v2.28).
// v2.28 — NEW-3 leader surface (PR1): a THIRD "To review" subtab "Just with you"
//   (pendingView 'justwithyou') listing the leader's own leader-only contributor pieces
//   (creatorType 'contributor' + visibilityPref 'owner_contributor_only'). Card affordance
//   "Ask to share this" -> handleShareRequest -> POST /memories/{id}/share-request (Endpoint A);
//   shows "Waiting to hear back" when memory.shareRequested, and a muted "✓ Shared before" when
//   memory.sharedBefore (a NEW-8 pull-back). "Shared" now EXCLUDES owner_contributor_only pieces
//   (in expandSharedEntries) so a pulled-back memory leaves Shared and lands here. Also removed the
//   stray padding on the NEW-8 "Remove from group" link. Behind group_spaces_enabled, dark.
//   Copy PLACEHOLDER -> thanatologist/brand-voice before enablement. (NEW3 frontend plan v0.2)
// v2.27 — NEW-8: leader "Remove from group" — an inline link on the Shared tab (same register as
//   the review actions, muted) on an approved contributor piece, POST /memories/{id}/review
//   {action:'unshare'}. handleReview learns 'unshare' (optimistic reviewStatus -> null; the link
//   then disappears). Behind group_spaces_enabled, dark. Copy/style PLACEHOLDER -> brand-voice +
//   design before enablement. Card stays on Shared (leader-only) until NEW-3's "Shared with you".
// v2.26 — NS-14: Waiting subview approve/decline converted from filled/outlined buttons
//   to inline text links in the olive register (Share with the group = #838B70; Set aside
//   = muted #737373), matching the Set-aside subview. Removes the last sage-green buttons
//   on this surface (ADR: primary decision stays visible, but as quiet links, not buttons).
// v2.25 — NS-14 copy settled (thanatologist v0.2): approval/verdict register -> stewardship.
//   Tab "To review"; subtabs "Waiting" / "Set aside"; card status "Set aside"; both share
//   actions "Share with the group"; decline "Set aside"; empty states reworded. Still dark
//   (groupSpacesEnabled). Contributor notification copy handled in anamoria-memories.
// v2.24 — NS-14 affordance polish (ADR-leader-row-action-affordances): "Share now"
//   is now a quiet inline text link (olive #838B70), not a filled button; the Pending /
//   Not shared subtabs are centered and use the Add-a-memory shape+color (8px, olive
//   #838B70) instead of full sage pills. Copy still placeholder — brand-voice before
//   enablement. Dark (groupSpacesEnabled). Frontend-only.
// v2.23 — NS-14: leader "Share now" (un-reject) on the Not-shared subtab.
//   handleReview learns action 'unreject' (→ approved; rolls back to the piece's
//   prior status, not a hard-coded 'pending'); the rejected-subview affordance
//   gains a "Share now" button → POST /memories/{id}/review {action:'unreject'}.
//   On success the piece leaves Not shared (filter) and appears on Shared.
//   Gated by groupSpacesEnabled + Pending Approval tab (dark). PLACEHOLDER copy —
//   brand-voice before enablement. (leader-share-adjustment-BUILD-plan-v0.3.md)
// v2.22 — Shared tab shows SHARED pieces (parallel to Favorites): a moment is
//   expanded into its non-private pieces (tagged momentId → card opens the
//   moment), so an individually-shared moment piece surfaces here as a
//   standalone shared memory (momentdetail sharing v0.8). Private/Pending
//   unchanged (moment-container behavior). Frontend-only.
// v2.21 — Favorites tab shows favorited PIECES (Option A): standalone favorited
//   memories pass through; moment entries are expanded into their favorited
//   pieces (tagged momentId → card opens the moment). handleFavorite/-Edit/-Click
//   handle nested pieces. Frontend-only; feed already returns pieces w/ isFavorite.
// v2.20 — feed_redesign_v2: pure-text tabs (July 27, 2026)
//   NEW prop feedRedesignEnabled (fail-closed). When true, adds .feedV2 to the
//   feed container (layered on .feedV) → pure-text tabs (no icons, sage
//   underline on active, sage divider under the row) via MemoryFeed.module.css
//   v2.8. Tab markup/logic unchanged; icons hidden by CSS. Flag off ⇒ byte-
//   identical. Tabs may later move out of the feed (Sophie) — same .tabs markup
//   kept so it's a lift-and-shift.
// v2.19 — B2a: Pending Approval tab + Pending/Rejected subtabs (July 27, 2026)
//
// Changes from v2.18 (moment-group-spaces-B2a-pending-approval-tab-plan-v0.3.md;
// dark unless `groupSpacesEnabled` — flag OFF byte-identical):
//   - NEW prop `groupSpacesEnabled = false` (fail-closed). Gates a "Pending
//     Approval" tab with Pending / Not-shared subtabs. Pending/rejected are
//     excluded from Shared so they surface only in their own tab.
//   - Per-card Approve / Not-now affordance (Option A — a bar on the pending
//     card; VoiceCard/VideoCard/photo/text internals untouched) → POST
//     /memories/{id}/review, optimistic (mirrors handleFavorite). PLACEHOLDER
//     copy — brand-voice before enablement.
//   - Macy recalc deps gain `pendingView` (inert when the flag is off).
//
// v2.18 — 3.2 moment navigation + scroll-return (July 21, 2026)
//
// Changes from v2.17 (momentdetail-3-2-DRAFT-for-review-v0.3.md E-6, A-1(a)):
//   - MomentCard call site gains onNavigate → /spaces/{id}/moments/{momentId}
//     (D-3.8; flagged branch only — legacy paths untouched).
//   - NEW prop `highlightMode` ('pulse' default | 'scroll'): the v2.14
//     highlight executor now pulses only in 'pulse' mode; 'scroll' (a plain
//     return from MomentDetailPage, F-D2(a)) scrolls without the gold pulse
//     (NN-g: the change-indicator belongs to changed content, v0.2 §E E-3).
//     Default preserves every existing call site's behaviour.
//   - NEW A-1 fallback executor: the v2.14 executor lives inside the Macy
//     recalc effect and never fires on the CSS fallback (G-8: no instance ⇒
//     bail). Flagged-only additive effect consumes pendingHighlightRef when
//     !loading && !macyReady; momentsEnabled guard keeps legacy byte-identical
//     (legacy notification-highlight fallback no-op = recorded carried item).
//
// v2.17 — 3.1-V flagged presentation pass (July 20, 2026)
//
// Changes from v2.16 (Phase 3 step 3.1-V; momentcard-3-1V-presentation-DRAFT-
// for-review-v0.4.md §2/§3; design of record v0.3 D-3.16..19, F-V1, F-V5/8/9):
//   - Macy config conditional on `momentsEnabled`: flagged = spec v3.0 §1.4
//     (columns 3/2/1 at 1024/768, margin {x:32,y:48} desktop / {28,40} tablet);
//     legacy object byte-identical (D-3.16 supersedes foundational plan §8.5
//     for the flagged feed only). Effect deps [] → [momentsEnabled] (F-V8).
//   - `feedV` class on both feedContainer divs when flagged: ground/tabs bg,
//     960/720 max-width, card-less legacy text/photo cards + sage hover tint
//     (F-V1 — legacy cards stay clickable; moment cards stay inert, D-3.13),
//     flagged fallback columns. Flag falsy ⇒ class absent ⇒ DOM byte-identical
//     to v2.16.
//
// v2.16 — Flagged unified-feed consumption + MomentCard rendering (July 20, 2026)
//
// Changes from v2.15 (Phase 3 step 3.1; momentcard-3-1-DRAFT-for-review-v0.4.md §4;
// plan v0.4 D-3.10/13/14/15; copy v0.4 §1/§4):
//   - NEW props `momentsEnabled = false`, `spaceName`. Flag falsy ⇒ every code
//     path byte-identical to v2.15 (fail-closed; undefined attrs render nothing).
//   - Flagged fetch: GET /spaces/{id}/feed (D-3.10), parses data.entries; cache
//     key `feed:{spaceId}` so a flag flip never serves the wrong shape;
//     invalidateMemoriesCache(spaceId) now deletes both keys (signature and
//     callers unchanged).
//   - Render: entries with entryType 'moment' → MomentCard v0.1 (inert, D-3.13)
//     in the same masonryItem wrapper; 'memory' entries → existing branches
//     untouched. Macy config byte-untouched.
//   - Tabs (D-3.15): moments use moment-level isPrivate for Private/Shared;
//     Favorites = legacy isFavorite entries only.
//   - Flagged empty states per copy v0.4 §1: true-empty (§1.1, spec v3.0 §1.12
//     posture — O-5 gate) + per-tab bodies (§1.2). Legacy strings byte-identical.
//   - BlurHashCanvas extracted to its own component (circular-import avoidance,
//     F-3); behaviour unchanged. Masonry container gets role/aria-label
//     "Memories" when flagged only (copy v0.4 §4).
//
// v2.15 — Contributor name attribution in card footers (June 27, 2026)
//
// Changes from v2.14:
//   - NEW formatCardAttribution helper: returns "Name · date" for contributor
//     memories, plain "date" for owner memories. Checks creatorType === 'contributor'
//     && creatorName (both now returned by anamoria-memories v2.14).
//   - Text card footer: uses formatCardAttribution instead of formatDate.
//   - Photo card footer: same change.
//   - VoiceCard and VideoCard receive creatorName on the memory object but
//     handle their own footer rendering (see VoiceCard v2.10, VideoCard v1.3).
//   - Zero other changes. Fetch, cache, Macy, tabs, navigation, favorites —
//     all byte-identical to v2.14.
//
// v2.14 — Event-driven highlight after Macy recalc (May 27, 2026)
//
// Changes from v2.13:
//   - Highlight scroll: replaced 300ms setTimeout with event-driven
//     coordination. highlightMemoryId is stored in a ref (pendingHighlightRef).
//     The Macy recalculation effect checks the ref after layout completes
//     and only then scrolls + applies the gold pulse. This eliminates the
//     jiggle caused by the animation racing Macy's repositioning.
//   - Removed the standalone highlightMemoryId useEffect (timer-based).
//   - Zero other changes.
//
// v2.13 — Reactive initialTab + highlightMemoryId (May 27, 2026)
//
// Changes from v2.12:
//   - NEW useEffect watching initialTab prop: when SpacePage passes a new
//     tab value (e.g., from a notification click while already on the space),
//     activeTab updates reactively. Previously initialTab was only consumed
//     in the useState initializer (mount-only), so same-route notification
//     clicks had no effect.
//   - NEW highlightMemoryId prop: when provided, after tab switch and render,
//     scrolls to the memory card with that ID and applies a brief gold
//     pulse animation (2s). Uses data-memory-id attributes on masonry items
//     and requestAnimationFrame to wait for DOM layout after tab change.
//   - NEW CSS class reference: styles.masonryItemHighlight — 2s gold pulse
//     keyframe applied to the matched masonry item, then removed.
//   - Zero other changes. Fetch, cache, Macy, tabs, cards, navigation,
//     favorites — all byte-identical to v2.12.
//
// v2.12 — Accept initialTab prop for notification navigation (May 17, 2026)
//
// Changes from v2.11:
//   - Accept optional initialTab prop. When provided (e.g., 'shared'),
//     sets the active tab on mount instead of defaulting to 'private'.
//   - Used by SpacePage when navigating from a notification click.
//   - Zero other changes.
//
// v2.11 — Favorites tab (May 16, 2026)
//
// Changes from v2.10:
//   - Added Favorites tab (third tab alongside Private / Shared).
//     Favorites shows all memories where isFavorite === true, regardless
//     of privacy setting. Client-side filter only — no new API call.
//   - Owner-only: MemoryFeed is only used in SpacePage (owner context).
//     ContributorFeedPage has its own feed component and is unaffected.
//   - Empty state for Favorites: heart icon + "No favorites yet" message.
//   - activeTab state expanded from 'private' | 'shared' to include 'favorites'.
//   - Macy recalculation dependency array includes activeTab (already did).
//   - FavoritesHeartIcon inline SVG for the tab.
//
// v2.10 — VideoCard integration (May 16, 2026)
//
// Changes from v2.9:
//   - Added VideoCard import and category === 'video' branch in masonry grid.
//     Video cards render between photo and text branches.
//   - handleCardClick: video navigates to /spaces/:id/video with editMode state
//     (same pattern as voice → RecordPage). No MemoryDetailPage involvement.
//   - handleEdit: video navigates to /spaces/:id/video with editMode + editing state
//     (same pattern as voice).
//   - cardOverlay hover selector updated to include .videoCard class.
//   - Zero changes to voice/text/photo branches. Zero changes to caching,
//     Macy, tabs, empty state, or any other existing logic.
//
// Changes from v2.8:
//   - No logic changes. Version bump to match MemoryFeed.module.css v2.4.
//   - With v2.4 architecture, the prompt section is above <main>, so
//     tabs stick at top:0 with nothing above them in the scroll container.
//
// v2.8 — Sticky tabs + feedPad wrapper (April 24, 2026)
//
// Changes from v2.7:
//   - Wrapped empty state and masonry grid in .feedPad div for side padding.
//     SpacePage .main no longer has padding (removed for full-width sticky prompt).
//   - Tabs now sticky via CSS (position: sticky in MemoryFeed.module.css v2.3).
//   - No logic changes. All rendering, caching, Macy, and interactions unchanged.
//
// v2.7 — D-5: Image dimensions for CLS fix (April 22, 2026)
//
// v2.6 — D-4: AbortController + fetchpriority + client-side cache (April 22, 2026)
//   - 6A: AbortController cleanup in memories fetch useEffect
//   - 5:  fetchpriority="high" on first photo, loading="lazy" on rest
//   - 6B: Module-level memories cache with 50-min TTL + exported invalidateMemoriesCache()
//
// v2.5 — BlurHash placeholders for photo cards (April 22, 2026)
//   - BlurHash canvas placeholder, onError fallback to original
//
// v2.3 — Inline signed URLs from memories response (April 22, 2026)
//
// v2.2 — Voice card theme passthrough (April 21, 2026)
//   - Accepts voiceCardTheme prop and forwards to VoiceCard as theme prop
//
// v2.1 — Voice edit routes to RecordPage (April 3, 2026)
//   - handleEdit: voice memories route to /spaces/:id/record with editMode state
//   - handleCardClick: voice cards route to RecordPage in edit mode
//
// Features (unchanged):
//   - Macy.js masonry layout (CDN loaded, CSS columns fallback)
//   - Private / Shared tabs (client-side filter on isPrivate)
//   - Photo cards with CloudFront signed URL from API response
//   - Voice cards (4 themes: warm, story, sage, clean)
//   - Text cards (white, amber "TEXT" label)
//   - Favorite toggle + edit icon overlays on all card types

import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import VoiceCard from './VoiceCard';
import VideoCard from './VideoCard';
import GroupMemoryCard, { isResponseCard, ResponseDay, ResponseChip } from './GroupMemoryCard';   // v2.47 (NEW-163)
import MomentCard from './MomentCard';
import FeedTags from './FeedTags';
import BlurHashCanvas from './BlurHashCanvas';
import { expandFavoriteEntries, expandSharedEntries, expandPrivateEntries } from '../utils/momentPieces';
import styles from './MemoryFeed.module.css';

/* ═══════════════════════════════════════
   HELPERS
   ═══════════════════════════════════════ */

function formatDate(dateStr) {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    const diff = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diff < 60) return 'just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return d.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
  } catch {
    return '';
  }
}

// v2.15: Attribution for card footers — contributor name + date for shared
// contributor memories, plain date for owner memories.
function formatCardAttribution(memory) {
  const date = memory.dayText?.trim() || formatDate(memory.createdAt);
  if (memory.creatorType === 'contributor' && memory.creatorName) {
    return `${memory.creatorName} \u00b7 ${date}`;
  }
  return date;
}

/* ─── Inline SVGs (from LWC axr_MediaCard.html) ─── */

function HeartIcon({ filled }) {
  if (filled) {
    return (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  );
}

function EditIcon() {
  return (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
    </svg>
  );
}

function PrivacyIcon({ isPrivate }) {
  if (isPrivate) {
    return (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#737373" strokeWidth="1.5" strokeLinecap="round">
        <rect x="5" y="11" width="14" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
      </svg>
    );
  }
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#737373" strokeWidth="1.5" strokeLinecap="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  );
}

/* v2.16: BlurHashCanvas moved to components/BlurHashCanvas.jsx (F-3). */

/* ═══════════════════════════════════════
   MEMORIES CACHE (D-4, Strategy 6B)
   Module-level cache with 50-minute TTL.
   Persists across navigations within the SPA.
   ═══════════════════════════════════════ */

const memoriesCache = new Map();
const CACHE_TTL_MS = 50 * 60 * 1000; // 50 minutes (below 60-min signed URL expiry)

function getCachedMemories(spaceId) {
  const entry = memoriesCache.get(spaceId);
  if (!entry) return null;
  if (Date.now() - entry.timestamp > CACHE_TTL_MS) {
    memoriesCache.delete(spaceId);
    return null;
  }
  return entry.data;
}

function setCachedMemories(spaceId, data) {
  memoriesCache.set(spaceId, { data, timestamp: Date.now() });
}

/**
 * Invalidate the memories cache for a given space.
 * Call this after creating, editing, or deleting a memory so the next
 * navigation to the feed fetches fresh data.
 */
export function invalidateMemoriesCache(spaceId) {
  if (spaceId) {
    memoriesCache.delete(spaceId);
    memoriesCache.delete(`feed:${spaceId}`); // v2.16: flagged-path key (3.1)
  } else {
    memoriesCache.clear();
  }
}

// v2.42 (feed video-refresh, 2026-09-28): a video memory is "still processing" when its
// videoNote exists but processingStatus isn't 'completed' yet (owner payload always has a
// videoNote once the video_notes row exists — unlike the contributor payload, which omits
// videoNote entirely until processing is done — see ContributorMemoryFeed.jsx's own
// isVideoPending for that contrast), and it's recent enough that processing genuinely
// still in flight is the likely explanation. Exported for test coverage.
export const PENDING_VIDEO_WINDOW_MS = 5 * 60 * 1000; // 5 minutes
export const POLL_SCHEDULE_MS = [5000, 5000, 8000, 13000]; // repeats the last value once exhausted
export const POLL_CAP_MS = 90 * 1000; // give up polling after this long since pending was first observed
export function isVideoPendingOwner(memory) {
  if (!memory || (memory.category || '').toLowerCase() !== 'video') return false;
  const vn = memory.videoNote;
  if (!vn || vn.processingStatus === 'completed') return false;
  const created = new Date(memory.createdAt).getTime();
  if (!created || Number.isNaN(created)) return false;
  return Date.now() - created < PENDING_VIDEO_WINDOW_MS;
}

/* ═══════════════════════════════════════
   MACY.JS DYNAMIC LOADER
   ═══════════════════════════════════════ */

let macyPromise = null;

function loadMacy() {
  if (macyPromise) return macyPromise;
  macyPromise = new Promise((resolve, reject) => {
    if (window.Macy) {
      resolve(window.Macy);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/macy@2/dist/macy.js';
    script.async = true;
    script.onload = () => resolve(window.Macy);
    script.onerror = () => {
      macyPromise = null; // allow retry
      reject(new Error('Failed to load Macy.js'));
    };
    document.head.appendChild(script);
  });
  return macyPromise;
}

/* ═══════════════════════════════════════
   MEMORY FEED COMPONENT
   ═══════════════════════════════════════ */

export default function MemoryFeed({ spaceId, getApi, onMemoryCount, voiceCardTheme, initialTab, highlightMemoryId, highlightMode = 'pulse', momentsEnabled = false, groupSpacesEnabled = false, feedRedesignEnabled = false, memberTagsEnabled = false, spaceName, spaceIsGroup = false, pendingReviewCount = 0, topSlot = null, groupNotes = null, leaderName = null }) {
  const navigate = useNavigate();
  const masonryRef = useRef(null);
  const macyInstanceRef = useRef(null);
  const tabsRef = useRef(null); // NEW-95: the tab row, watched for horizontal overflow

  const [memories, setMemories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState(initialTab || 'private'); // 'private' | 'shared' | 'favorites' | 'pending'
  const [macyReady, setMacyReady] = useState(false);
  // B2a: within the Pending Approval tab, which subview is shown (dark unless group_spaces_enabled).
  const [pendingView, setPendingView] = useState('pending'); // 'pending' | 'rejected'
  const [reviewingId, setReviewingId] = useState(null); // memory id currently being approved/rejected

  // v2.36: the "To review" (pending) tab belongs to GROUP spaces (per-space is_group_space).
  const reviewTabEnabled = groupSpacesEnabled && spaceIsGroup;

  // v2.36: if the active tab is the review tab but this isn't a group space (e.g. an old
  // notification deep-link into a private space), fall back to Private so the review surface
  // never renders where it doesn't belong.
  useEffect(() => {
    if (activeTab === 'pending' && !reviewTabEnabled) setActiveTab('private');
  }, [activeTab, reviewTabEnabled]);

  // NEW-95: flag the tab row when it overflows its width, so CSS shows a scroll affordance
  // (right-edge fade) only when there's more to reveal. Presentational only — no state,
  // no behaviour change. ResizeObserver is supported on all target browsers.
  useEffect(() => {
    const el = tabsRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const update = () => { el.dataset.overflowing = String(el.scrollWidth > el.clientWidth + 1); };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [reviewTabEnabled, activeTab, loading]);

  // v2.13: Reactive tab switch — when initialTab prop changes (e.g., from
  // a notification click while already on the space page), update activeTab.
  // The useState initializer only runs on mount; this effect handles updates.
  useEffect(() => {
    if (initialTab && initialTab !== activeTab) {
      setActiveTab(initialTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialTab]);

  // v2.14: Store pending highlight in a ref. The Macy recalculation effect
  // reads this ref after layout completes and triggers scroll + highlight.
  // This replaces the v2.13 setTimeout approach which raced Macy repositioning.
  const pendingHighlightRef = useRef(null);

  useEffect(() => {
    if (highlightMemoryId) {
      pendingHighlightRef.current = highlightMemoryId;
    }
  }, [highlightMemoryId]);

  /* ─── Fetch memories (D-4: AbortController + cache) ───
     v2.42 (feed video-refresh): loadMemories is now reusable (mount effect below, plus the
     focus/visibility + poll effects further down) instead of an effect-local closure. Cache
     behavior for a plain mount/spaceId-change call is byte-identical to before — this only
     adds the ability for a caller to pass bypassCache:true, which mount never does. */
  const abortRef = useRef(null);

  const loadMemories = useCallback(async ({ bypassCache = false, silent = false } = {}) => {
    // v2.16: flagged path fetches the unified feed under its own cache key
    // (D-3.10; a flag flip must never serve the wrong shape).
    const cacheKey = momentsEnabled ? `feed:${spaceId}` : spaceId;

    // 6B: Check cache first — instant render on return visits (skipped only when a
    // background refresh has already determined a pending video needs fresh data).
    if (!bypassCache) {
      const cached = getCachedMemories(cacheKey);
      if (cached) {
        setMemories(cached);
        if (onMemoryCount) onMemoryCount(cached.length);
        setLoading(false);
        return;
      }
    }

    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    if (!silent) setLoading(true);
    try {
      const api = getApi();
      const data = await api.get(
        momentsEnabled
          ? `/spaces/${spaceId}/feed?limit=100&offset=0`
          : `/spaces/${spaceId}/memories?limit=100&offset=0`,
        { signal: controller.signal }
      );
      if (controller.signal.aborted) return;
      const mems = (momentsEnabled ? data.entries : data.memories) || [];
      setMemories(mems);
      setCachedMemories(cacheKey, mems); // keep the cache correct, whether this was the normal path or a bypass
      if (onMemoryCount) onMemoryCount(mems.length);
      if (!silent) setError('');
    } catch (err) {
      if (err.name === 'AbortError' || controller.signal.aborted) return; // expected during cleanup
      if (!silent) setError('Could not load memories.');
    } finally {
      if (!controller.signal.aborted && !silent) setLoading(false);
    }
  }, [spaceId, getApi, onMemoryCount, momentsEnabled]);

  useEffect(() => {
    loadMemories();
    return () => { if (abortRef.current) abortRef.current.abort(); };
  }, [loadMemories]);

  /* ─── Refetch on focus/visibility — gated (v2.42, feed video-refresh) ───
     Deliberately NOT unconditional (contrast with ContributorMemoryFeed.jsx, which has no
     cache to protect): only bypasses the cache when the currently-known memories actually
     contain a pending video. No pending video → this is a no-op and the 50-minute cache's
     instant-render behavior is completely unaffected. */
  useEffect(() => {
    function maybeRefresh() {
      if (memories.some(isVideoPendingOwner)) {
        loadMemories({ bypassCache: true, silent: true });
      }
    }
    function handleVisibility() {
      if (!document.hidden) maybeRefresh();
    }
    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('focus', maybeRefresh);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('focus', maybeRefresh);
    };
  }, [memories, loadMemories]);

  /* ─── Bounded, backing-off poll while a video is still processing (v2.42) ───
     Same schedule/cap as the contributor-side equivalent; always bypasses the cache (there's
     no point polling a value that can't change) and writes the fresh result back into it. */
  const pollTimerRef = useRef(null);
  const pollStepRef = useRef(0);
  const pollStartedAtRef = useRef(null);

  useEffect(() => {
    const clearPoll = () => {
      if (pollTimerRef.current) {
        clearTimeout(pollTimerRef.current);
        pollTimerRef.current = null;
      }
    };

    const pending = memories.some(isVideoPendingOwner);

    if (!pending) {
      clearPoll();
      pollStepRef.current = 0;
      pollStartedAtRef.current = null;
      return undefined;
    }

    if (document.hidden) {
      clearPoll();
      return undefined;
    }

    if (pollStartedAtRef.current === null) pollStartedAtRef.current = Date.now();
    if (Date.now() - pollStartedAtRef.current > POLL_CAP_MS) {
      clearPoll();
      return undefined;
    }

    const step = Math.min(pollStepRef.current, POLL_SCHEDULE_MS.length - 1);
    pollTimerRef.current = setTimeout(() => {
      pollStepRef.current += 1;
      loadMemories({ bypassCache: true, silent: true });
    }, POLL_SCHEDULE_MS[step]);

    return clearPoll;
  }, [memories, loadMemories]);

  // v2.3: Photo URL fetch loop removed — playbackUrl now comes from memories API response

  /* ─── Initialize Macy.js ─── */

  useEffect(() => {
    let instance = null;
    let cancelled = false;

    loadMacy()
      .then((Macy) => {
        if (cancelled || !masonryRef.current) return;

        instance = Macy({
          container: masonryRef.current,
          trueOrder: false,
          waitForImages: true,
          // v2.17 (3.1-V, D-3.16): flagged feed = spec v3.0 §1.4; legacy byte-identical
          margin: momentsEnabled ? { x: 32, y: 48 } : 16,
          columns: momentsEnabled ? 4 : 5, // PREVIEW (Sophie): 3 (closed D-3.16) → 4 → 5 → back to 4; re-close on verdict
          breakAt: momentsEnabled
            ? {
                1023: { columns: 2, margin: { x: 28, y: 40 } },
                767: { columns: 1 },
              }
            : {
                1279: 4,
                899: 3,
                599: 2,
              },
        });

        macyInstanceRef.current = instance;

        if (instance.on) {
          instance.on(instance.constants.EVENT_IMAGE_COMPLETE, () => {
            instance.recalculate(true, true);
          });
        }

        if (!cancelled) setMacyReady(true);
      })
      .catch(() => {
        if (!cancelled) setMacyReady(false);
      });

    return () => {
      cancelled = true;
      if (instance) {
        try { instance.remove(); } catch { /* ignore */ }
      }
      macyInstanceRef.current = null;
    };
  }, [momentsEnabled]); // v2.17 (F-V8): config depends on the flag; re-init on change.
  // G-8 (gate find, 2026-07-20, REVERTED SAME DAY): this effect's
  // !masonryRef.current bail silently leaves the feed on the CSS fallback
  // whenever the (cached) Macy script resolves before the data fetch —
  // nothing retries once the grid div renders. Latent since v2.x; invisible
  // because the fallback mirrors the Macy column counts. Adding `loading` to
  // the deps fixed first-load but broke navigate-away-and-back on the legacy
  // feed (stale macyReady=true with no live instance; resize didn't recover).
  // Fix reverted; proper lifecycle rework = its own change (carried item).
  // MITIGATION: flagged fallback CSS must always mirror the flagged Macy
  // config exactly, as legacy's does, so the race stays invisible.

  /* ─── Recalculate Macy when data changes ─── */
  // v2.3: Removed photoUrls from dependency array (no longer exists)
  // v2.14: After final recalculation, check pendingHighlightRef and scroll
  // to the target memory card. This ensures the card is in its final
  // position before we scroll and animate — no jiggle.

  useEffect(() => {
    const inst = macyInstanceRef.current;
    if (!inst) return;

    const raf1 = requestAnimationFrame(() => {
      inst.recalculate(true, true);
      const raf2 = requestAnimationFrame(() => {
        inst.recalculate(true, true);

        // v2.14: Macy layout is settled — execute pending highlight if any
        const memoryId = pendingHighlightRef.current;
        if (memoryId) {
          pendingHighlightRef.current = null; // Consume — only fire once
          requestAnimationFrame(() => {
            const el = document.querySelector(`[data-memory-id="${memoryId}"]`);
            if (el) {
              el.scrollIntoView({ behavior: 'smooth', block: 'center' });
              // 3.2 (F-E3/NN-g): the pulse signals CHANGED content — a plain
              // return from detail ('scroll' mode) scrolls only.
              if (highlightMode !== 'scroll') {
                el.classList.add(styles.masonryItemHighlight);
                setTimeout(() => {
                  el.classList.remove(styles.masonryItemHighlight);
                }, 2000);
              }
            }
          });
        }
      });
      return () => cancelAnimationFrame(raf2);
    });

    return () => cancelAnimationFrame(raf1);
  }, [memories, activeTab, pendingView, highlightMode]);

  // 3.2 (A-1): fallback-path highlight executor — the v2.14 executor above
  // lives inside the Macy recalc effect and never fires when the feed renders
  // on the CSS fallback (G-8: no instance ⇒ bail). Flagged feed only —
  // momentsEnabled guard keeps the legacy path byte-identical; the legacy
  // notification-highlight fallback no-op is a recorded carried item, not
  // fixed here. Known imperfection (recorded): if Macy initialises after this
  // scroll, relayout can shift the target — re-eyeball at gate.
  useEffect(() => {
    if (!momentsEnabled || loading || macyReady) return;
    const memoryId = pendingHighlightRef.current;
    if (!memoryId) return;
    pendingHighlightRef.current = null; // Consume — only fire once
    const raf = requestAnimationFrame(() => {
      const el = document.querySelector(`[data-memory-id="${memoryId}"]`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (highlightMode !== 'scroll') {
          el.classList.add(styles.masonryItemHighlight);
          setTimeout(() => {
            el.classList.remove(styles.masonryItemHighlight);
          }, 2000);
        }
      }
    });
    return () => cancelAnimationFrame(raf);
  }, [momentsEnabled, loading, macyReady, memories, pendingView, highlightMode]);

  /* ─── Recalculate on photo image load ─── */

  const handleImageLoad = useCallback(() => {
    const inst = macyInstanceRef.current;
    if (inst) {
      requestAnimationFrame(() => inst.recalculate(true, true));
    }
  }, []);

  /* ─── Filter by tab ─── */

  // v2.21 (Option A): the Favorites tab shows favorited PIECES. Standalone
  // favorited memories pass through; moment entries are expanded into their
  // favorited pieces (tagged with momentId so the card opens its moment).
  // Every other tab keeps the v2.16 moment-container behavior, byte-identical.
  // v2.22: the Shared tab, like Favorites, expands moments into their SHARED
  // pieces (an individually-shared moment piece surfaces here as a standalone
  // shared memory — momentdetail sharing v0.8). Private/Pending keep the v2.16
  // moment-container behavior, byte-identical.
  const filteredMemories = activeTab === 'favorites'
    ? expandFavoriteEntries(memories)
    : activeTab === 'shared'
    ? expandSharedEntries(memories, { groupSpacesEnabled })
    : activeTab === 'private'
    ? expandPrivateEntries(memories, { groupSpacesEnabled })
    : memories.filter((m) => {
        if (m.entryType === 'moment') {
          if (groupSpacesEnabled && activeTab === 'pending') return false; // moments are containers, not contributor approvals
          if (activeTab === 'private') return m.isPrivate;
          return !m.isPrivate;
        }
        if (activeTab === 'private') return m.isPrivate;
        // B2a: group-spaces approval views. Flag OFF ⇒ falls straight through to
        // the legacy Shared rule below, byte-identical.
        if (groupSpacesEnabled) {
          if (activeTab === 'pending') {
            // NEW-3: third subtab — the leader's own leader-only contributor pieces.
            if (pendingView === 'justwithyou') return m.creatorType === 'contributor' && m.visibilityPref === 'owner_contributor_only';
            return m.reviewStatus === pendingView; // 'pending' | 'rejected'
          }
          // Shared excludes items awaiting review or declined; they surface only in their own tab.
          return !m.isPrivate && m.reviewStatus !== 'pending' && m.reviewStatus !== 'rejected';
        }
        return !m.isPrivate;
      });

  /* ─── Navigation ─── */

  // v2.1: Voice cards go to RecordPage in edit mode; text/photo go to MemoryDetailPage
  const handleCardClick = useCallback((memory) => {
    if (memory.creatorType === 'contributor') { // NEW-66: contributor memory opens read-only, never the editors
      navigate(`/spaces/${spaceId}/memories/${memory.id}`, { state: { memory } });
      return;
    }
    // v2.21: a piece surfaced in the Favorites tab opens its parent moment.
    if (memory.momentId) {
      navigate(`/spaces/${spaceId}/moments/${memory.momentId}`, {
        state: { memoryId: memory.momentId, scrollOnly: true },
      });
      return;
    }
    const category = (memory.category || '').toLowerCase();
    if (category === 'voice') {
      navigate(`/spaces/${spaceId}/record`, {
        state: { editMode: true, editMemory: memory },
      });
    } else if (category === 'video') {
      navigate(`/spaces/${spaceId}/video`, {
        state: { editMode: true, editMemory: memory },
      });
    } else {
      navigate(`/spaces/${spaceId}/memories/${memory.id}`, {
        state: { memory },
      });
    }
  }, [navigate, spaceId]);

  // v2.1: Voice edit → RecordPage; video edit → VideoPage; text/photo edit → MemoryDetailPage
  const handleEdit = useCallback((memory) => {
    if (memory.creatorType === 'contributor') return; // NEW-66: no owner edit of a contributor memory
    // v2.21: pieces surfaced from a moment are edited in the moment, not standalone.
    if (memory.momentId) {
      navigate(`/spaces/${spaceId}/moments/${memory.momentId}`, {
        state: { memoryId: memory.momentId, scrollOnly: true },
      });
      return;
    }
    const category = (memory.category || '').toLowerCase();
    if (category === 'voice') {
      navigate(`/spaces/${spaceId}/record`, {
        state: { editMode: true, editMemory: memory },
      });
    } else if (category === 'video') {
      navigate(`/spaces/${spaceId}/video`, {
        state: { editMode: true, editMemory: memory },
      });
    } else {
      navigate(`/spaces/${spaceId}/memories/${memory.id}`, {
        state: { memory, editing: true },
      });
    }
  }, [navigate, spaceId]);

  /* ─── Favorite toggle (optimistic update) ─── */

  const handleFavorite = useCallback(async (memory) => {
    const newVal = !memory.isFavorite;
    // v2.21: the target may be a top-level entry OR a piece nested in a moment
    // entry (the Favorites tab expands moments into their favorited pieces).
    const setFav = (val) => (m) => {
      if (m.entryType === 'moment') {
        if (!(m.pieces || []).some((p) => p.id === memory.id)) return m;
        return { ...m, pieces: m.pieces.map((p) => (p.id === memory.id ? { ...p, isFavorite: val } : p)) };
      }
      return m.id === memory.id ? { ...m, isFavorite: val } : m;
    };

    setMemories((prev) => prev.map(setFav(newVal)));

    try {
      const api = getApi();
      const result = await api.post(`/memories/${memory.id}/favorite`);
      if (result && result.isFavorite !== undefined) {
        setMemories((prev) => prev.map(setFav(result.isFavorite)));
      }
    } catch (err) {
      console.error('Favorite toggle failed:', err);
      setMemories((prev) => prev.map(setFav(!newVal)));
    }
  }, [getApi]);

  /* ─── B2a: approve / not-now (optimistic), mirrors handleFavorite. POST /memories/{id}/review ─── */

  const handleReview = useCallback(async (memory, action) => {
    const prevStatus = memory.reviewStatus;                          // for accurate rollback
    const prevVisibilityPref = memory.visibilityPref;               // for accurate rollback (unshare)
    const prevSharedBefore = memory.sharedBefore;                   // for accurate rollback (unshare)
    const newStatus = action === 'reject' ? 'rejected' : action === 'unshare' ? null : 'approved'; // approve & unreject -> approved; NEW-8 unshare -> null (leaves the group)
    // 'unshare': flip visibilityPref + set sharedBefore immediately so the card leaves Shared,
    // surfaces in "Just with you", and shows the "✓ Shared before" checkmark — all without a
    // page reload. Backend sets visibility_pref='owner_contributor_only' + writes the 'unshare'
    // audit row (sharedBefore EXISTS query) on the same call.
    const optimisticExtra = action === 'unshare' ? { visibilityPref: 'owner_contributor_only', sharedBefore: true } : {};
    setReviewingId(memory.id);
    setMemories((prev) =>
      prev.map((m) => (m.id === memory.id ? { ...m, reviewStatus: newStatus, ...optimisticExtra } : m))
    );
    // Auto-switch to "Set aside" subtab after reject so the memory stays in view rather than
    // vanishing (previously the user had to switch tabs manually to find it).
    if (action === 'reject') setPendingView('rejected');
    try {
      const api = getApi();
      const result = await api.post(`/memories/${memory.id}/review`, { action });
      if (result && result.reviewStatus) {
        setMemories((prev) =>
          prev.map((m) => (m.id === memory.id ? { ...m, reviewStatus: result.reviewStatus } : m))
        );
      }
      // Bust the cache so a return-navigation (remount + cache hit) sees the post-review state,
      // not a stale snapshot from before the action.
      invalidateMemoriesCache(spaceId);
    } catch (err) {
      console.error('Review action failed:', err);
      setMemories((prev) =>
        prev.map((m) => (m.id === memory.id ? { ...m, reviewStatus: prevStatus, visibilityPref: prevVisibilityPref, sharedBefore: prevSharedBefore } : m))
      );
    } finally {
      setReviewingId(null);
    }
  }, [getApi, spaceId]);

  /* ─── NEW-3: leader "Ask to share this" (optimistic), mirrors handleReview. POST /memories/{id}/share-request ─── */
  const handleShareRequest = useCallback(async (memory) => {
    setReviewingId(memory.id);
    setMemories((prev) =>
      prev.map((m) => (m.id === memory.id ? { ...m, shareRequested: true } : m))   // -> "Waiting to hear back"
    );
    try {
      const api = getApi();
      await api.post(`/memories/${memory.id}/share-request`, {});
    } catch (err) {
      console.error('Share request failed:', err);
      setMemories((prev) =>
        prev.map((m) => (m.id === memory.id ? { ...m, shareRequested: false } : m))   // rollback
      );
    } finally {
      setReviewingId(null);
    }
  }, [getApi]);

  /* ─── B2a: per-card approval affordance (Option A — a bar on the pending card; shared
         card components untouched). Inline styles avoid CSS-module changes. Returns null
         outside the Pending Approval tab, so normal tabs render byte-identically.
         PLACEHOLDER copy + styling — brand-voice + design pass before enablement. ─── */

  const renderPendingAffordance = (memory) => {
    if (!groupSpacesEnabled) return null;
    // NEW-8: leader "Remove from group" on the Shared tab — a previously-approved contributor
    // piece the leader can quietly pull back to just-them (POST /memories/{id}/review action
    // 'unshare'). Same inline-link register as the review actions; muted, since it's a quiet
    // pull-back not a bright CTA. PLACEHOLDER copy/style pending brand-voice + design. On success
    // reviewStatus clears (optimistic null) and visibilityPref -> owner_contributor_only, so the
    // piece leaves Shared (excluded in expandSharedEntries) and reappears in the "Just with you"
    // subtab (NEW-3) with a "✓ Shared before" flag.
    if (activeTab === 'shared' && memory.creatorType === 'contributor' && memory.reviewStatus === 'approved') {
      const busy = reviewingId === memory.id;
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '18px', padding: '6px 4px 2px' }}>
          <button
            type="button"
            disabled={busy}
            onClick={(e) => { e.stopPropagation(); handleReview(memory, 'unshare'); }}
            style={{
              background: 'none', border: 'none',
              color: '#737373', fontSize: '0.82rem', fontWeight: 600,
              cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.5 : 1,
            }}
          >
            Remove from group
          </button>
        </div>
      );
    }
    if (activeTab !== 'pending') return null;
    // NEW-3: "Just with you" subtab — leader-only contributor pieces. "Ask to share this" -> Endpoint A;
    // "Waiting to hear back" once asked (a 2nd ask 404s); "✓ Shared before" if pulled back (NEW-8).
    // PLACEHOLDER copy/style pending thanatologist/brand-voice.
    if (pendingView === 'justwithyou') {
      const busy = reviewingId === memory.id;
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '6px 4px 2px' }}>
          {memory.sharedBefore && (
            <span style={{ fontSize: '0.72rem', color: '#8a8a8a' }}>Shared before</span>
          )}
          <span style={{ flex: 1 }} />
          {memory.shareRequested ? (
            <span style={{ fontSize: '0.82rem', color: '#8a8a8a', fontWeight: 600 }}>
              {memory.creatorName ? `Waiting for ${memory.creatorName}` : 'Waiting to hear back'}
            </span>
          ) : memory.shareDeclined ? (
            <span style={{ fontSize: '0.82rem', color: '#b0b0b0' }}>Kept between us</span>
          ) : (
            <button
              type="button"
              disabled={busy}
              onClick={(e) => { e.stopPropagation(); handleShareRequest(memory); }}
              style={{
                background: 'none', border: 'none',
                color: 'var(--moment-accent)', fontSize: '0.82rem', fontWeight: 600,
                cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.5 : 1,
              }}
            >
              Ask to share with group
            </button>
          )}
        </div>
      );
    }
    if (pendingView === 'rejected') {
      const busy = reviewingId === memory.id;
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '6px 4px 2px' }}>
          <span style={{ flex: 1, fontSize: '0.72rem', color: '#8a8a8a' }}>
            Set aside
          </span>
          <button
            type="button"
            disabled={busy}
            onClick={(e) => { e.stopPropagation(); handleReview(memory, 'unreject'); }}
            style={{
              background: 'none', border: 'none', padding: '10px 6px',
              color: 'var(--moment-accent)', fontSize: '0.82rem', fontWeight: 600,
              cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.5 : 1,
            }}
          >
            Share with the group
          </button>
        </div>
      );
    }
    const busy = reviewingId === memory.id;
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '18px', padding: '6px 4px 2px' }}>
        <button
          type="button"
          disabled={busy}
          onClick={(e) => { e.stopPropagation(); handleReview(memory, 'approve'); }}
          style={{
            background: 'none', border: 'none', padding: '10px 6px',
            color: 'var(--moment-accent)', fontSize: '0.82rem', fontWeight: 600,
            cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.5 : 1,
          }}
        >
          Share with the group
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={(e) => { e.stopPropagation(); handleReview(memory, 'reject'); }}
          style={{
            background: 'none', border: 'none', padding: '10px 6px',
            color: '#737373', fontSize: '0.82rem', fontWeight: 600,
            cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.5 : 1,
          }}
        >
          Set aside
        </button>
      </div>
    );
  };

  /* ─── Render states ─── */

  if (loading) {
    return (
      <div className={styles.loading}>
        <div className="app-loading-spinner" />
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.error}>
        <p>{error}</p>
      </div>
    );
  }

  // v2.16 (D-3.7b): flagged true-empty — nothing in the space on any tab.
  // Single-column centered per spec v3.0 §1.12 (no tabs — nothing to filter).
  // Strings = copy v0.4 §1.1 (v2.44: one gentle descriptive line; no {name}, same copy for personal + group).
  if (momentsEnabled && memories.length === 0) {
    return (
      <div className={`${styles.feedContainer}${momentsEnabled ? ` ${styles.feedV}` : ''}${feedRedesignEnabled ? ` ${styles.feedV2}` : ''}`}>
        <div className={styles.trueEmpty}>
          <p className={styles.trueEmptyText}>
            A memory can be a photo, something written, a recording, or simply
            a day that matters.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.feedContainer}${momentsEnabled ? ` ${styles.feedV}` : ''}${feedRedesignEnabled ? ` ${styles.feedV2}` : ''}`}>

      {/* ─── Private / Shared / Favorites Tabs ─── */}
      <div className={styles.tabs} ref={tabsRef} data-overflowing="false" data-tour="feed-tabs">
        <button
          className={`${styles.tab} ${activeTab === 'private' ? styles.tabActive : ''}`}
          onClick={() => setActiveTab('private')}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
            <rect x="5" y="11" width="14" height="10" rx="2" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
          </svg>
          Private
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'shared' ? styles.tabActive : ''}`}
          onClick={() => setActiveTab('shared')}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          Shared
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'favorites' ? styles.tabActive : ''}`}
          onClick={() => setActiveTab('favorites')}
        >
          <svg className={styles.favTabHeart} width="14" height="14" viewBox="0 0 24 24" fill={activeTab === 'favorites' ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.5">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
          </svg>
          Favorites
        </button>
        {/* B2a: "To review" tab — dark unless group_spaces_enabled. v2.36: also requires a
            GROUP space (reviewTabEnabled = groupSpacesEnabled && spaceIsGroup). */}
        {reviewTabEnabled && (
          <button
            className={`${styles.tab} ${activeTab === 'pending' ? styles.tabActive : ''}`}
            onClick={() => setActiveTab('pending')}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v5l3 2" />
            </svg>
            To review
            {pendingReviewCount > 0 && (
              <span style={{ marginLeft: 7, background: '#E7E1D5', color: '#6b6b63', borderRadius: 20, padding: '1px 8px', fontSize: '0.72rem', fontWeight: 600 }}>{pendingReviewCount}</span>
            )}
          </button>
        )}
      </div>
      {/* B2a: Waiting / Set aside subtabs — dark. Copy settled (thanatologist v0.2); styling per ADR. */}
      {reviewTabEnabled && activeTab === 'pending' && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', padding: '8px 12px 0' }}>
          <button
            type="button"
            onClick={() => setPendingView('pending')}
            style={{
              padding: '7px 16px', borderRadius: '8px', fontSize: '0.8rem', cursor: 'pointer',
              border: '1px solid var(--moment-action-brand)',
              background: pendingView === 'pending' ? 'var(--moment-action-brand)' : 'transparent',
              color: pendingView === 'pending' ? '#fff' : 'var(--moment-action-brand)',
            }}
          >
            Waiting
          </button>
          <button
            type="button"
            onClick={() => setPendingView('rejected')}
            style={{
              padding: '7px 16px', borderRadius: '8px', fontSize: '0.8rem', cursor: 'pointer',
              border: '1px solid var(--moment-action-brand)',
              background: pendingView === 'rejected' ? 'var(--moment-action-brand)' : 'transparent',
              color: pendingView === 'rejected' ? '#fff' : 'var(--moment-action-brand)',
            }}
          >
            Set aside
          </button>
          {/* NEW-3: third subtab — leader-only contributor pieces. Copy PLACEHOLDER. */}
          <button
            type="button"
            onClick={() => setPendingView('justwithyou')}
            style={{
              padding: '7px 16px', borderRadius: '8px', fontSize: '0.8rem', cursor: 'pointer',
              border: '1px solid var(--moment-action-brand)',
              background: pendingView === 'justwithyou' ? 'var(--moment-action-brand)' : 'transparent',
              color: pendingView === 'justwithyou' ? '#fff' : 'var(--moment-action-brand)',
            }}
          >
            Just with you
          </button>
        </div>
      )}

      {/* v2.8: feedPad wraps content below sticky tabs — provides side padding
          since SpacePage .main no longer has padding (removed for full-width sticky prompt) */}
      <div className={styles.feedPad}>

      {/* v2.46 (NEW-162): caller-provided slot under the tabs, on the SHARED tab only (the leader note
          belongs with the group's shared conversation; Private / Favorites / To review are the leader's own). */}
      {activeTab === 'shared' ? topSlot : null}

      {/* ─── B2a: review empty state (dark). Copy settled (thanatologist v0.2). ─── */}
      {filteredMemories.length === 0 && reviewTabEnabled && activeTab === 'pending' && (
        <div className={styles.empty}>
          {/* NEW-3: 'justwithyou' empty state — copy PLACEHOLDER pending thanatologist/brand-voice. */}
          <span className={styles.emptyIcon}>{pendingView === 'rejected' ? '🚫' : pendingView === 'justwithyou' ? '🤍' : '⏳'}</span>
          <p className={styles.emptyTitle}>
            {pendingView === 'rejected' ? 'Nothing set aside' : pendingView === 'justwithyou' ? 'Nothing just with you yet' : 'Nothing waiting right now'}
          </p>
          <p className={styles.emptyText}>
            {pendingView === 'rejected'
              ? 'Memories you set aside will be here, and you can share them with the group any time.'
              : pendingView === 'justwithyou'
                ? 'Memories a contributor has shared just with you will appear here. You can ask them to share with the group.'
                : 'When someone shares a memory with the group, it will wait here for you.'}
          </p>
        </div>
      )}

      {/* ─── Empty state ─── */}
      {filteredMemories.length === 0 && !(reviewTabEnabled && activeTab === 'pending') && (
        <div className={styles.empty}>
          <span className={styles.emptyIcon}>
            {activeTab === 'favorites' ? '♡' : activeTab === 'private' ? '🔒' : '👨‍👩‍👧‍👦'}
          </span>
          <p className={styles.emptyTitle}>
            {activeTab === 'favorites'
              ? 'No favorites yet'
              : activeTab === 'private'
                ? 'No private memories yet'
                : 'No shared memories yet'}
          </p>
          <p className={styles.emptyText}>
            {/* v2.16: flagged bodies per copy v0.4 \u00a71.2; legacy strings byte-identical */}
            {activeTab === 'favorites'
              ? (momentsEnabled
                  ? 'Use the heart on any memory to keep it here.'
                  : 'Tap the heart on any memory to save it here.')
              : activeTab === 'private'
                ? (momentsEnabled
                    ? 'Memories are private unless you choose to share them. They\u2019ll appear here.'
                    : 'Memories you record are private by default. They\u2019ll appear here.')
                : (momentsEnabled
                    ? 'When you share a memory, it will appear here, and the people you\u2019ve invited can see it.'
                    : 'When you mark memories as shared, they\u2019ll be visible to family members.')}
          </p>
        </div>
      )}

      {/* ─── Masonry Grid ─── */}
      {filteredMemories.length > 0 && (() => {
        let photoIndex = 0; // v2.6: tracks photo position for fetchpriority
        return (
        <div
          ref={masonryRef}
          className={`${styles.masonry} ${!macyReady ? styles.masonryFallback : ''}`}
          role={momentsEnabled ? 'region' : undefined}
          aria-label={momentsEnabled ? 'Memories' : undefined}
        >
          {filteredMemories.map((memory) => {
            /* ── Moment card (v2.16, 3.1 — flagged feed only) ── */
            if (memory.entryType === 'moment') {
              return (
                <div key={memory.id} className={styles.masonryItem} data-memory-id={memory.id}>
                  <MomentCard
                    moment={memory}
                    voiceCardTheme={voiceCardTheme}
                    getApi={getApi}
                    onImageLoad={handleImageLoad}
                    onNavigate={(m) => navigate(`/spaces/${spaceId}/moments/${m.id}`)}
                    redesign={feedRedesignEnabled}
                    spaceIsGroup={spaceIsGroup}
                  />
                  {memberTagsEnabled && <FeedTags entry={memory} onOpen={() => navigate(`/spaces/${spaceId}/moments/${memory.id}`)} />}
                </div>
              );
            }

            const category = (memory.category || '').toLowerCase();
            // v2.47 (NEW-163): response-card header iff groupNoteId && spaceIsGroup (never the leader's own).
            const responseHeader = isResponseCard(memory, spaceIsGroup)
              ? <GroupMemoryCard memory={memory} groupNotes={groupNotes} leaderName={leaderName} padX={feedRedesignEnabled ? 20 : 14} />
              : null;
            const responseDay = responseHeader ? <ResponseDay memory={memory} /> : null;                              // footer left: "Today"
            const responseChip = responseHeader ? <ResponseChip memory={memory} category={category} /> : null;       // footer right, before the privacy icon

            /* ── Voice card ── */
            if (category === 'voice') {
              return (
                <div key={memory.id} className={styles.masonryItem} data-memory-id={memory.id}>
                  <VoiceCard
                    memory={memory}
                    getApi={getApi}
                    theme={voiceCardTheme || 'warm'}
                    onFavorite={handleFavorite}
                    onEdit={handleEdit}
                    onClick={handleCardClick}
                    redesign={feedRedesignEnabled}
                    spaceIsGroup={spaceIsGroup}
                    headerSlot={responseHeader}
                    footerSlot={responseDay}
                    footerEndSlot={responseChip}
                  />
                  {renderPendingAffordance(memory)}
                  {memberTagsEnabled && <FeedTags entry={memory} onOpen={() => handleCardClick(memory)} />}
                </div>
              );
            }

            /* ── Photo card ── */
            if (category === 'photo') {
              // v2.6: fetchpriority + lazy loading + BlurHash + onError fallback
              const photoUrl = memory.playbackUrl;
              const fallbackUrl = memory.originalPlaybackUrl;
              const isFirstPhoto = photoIndex === 0;
              photoIndex++;

              // v2.7 (D-5): Compute aspect-ratio style from image dimensions
              const photoAspectStyle = memory.imageWidth && memory.imageHeight
                ? { aspectRatio: `${memory.imageWidth} / ${memory.imageHeight}` }
                : { aspectRatio: '4 / 3' };

              // v2.7 (D-5): BlurHash canvas dimensions matched to actual image ratio
              const blurWidth = 269;
              const blurHeight = (memory.imageWidth && memory.imageHeight)
                ? Math.round(blurWidth * memory.imageHeight / memory.imageWidth)
                : 180;

              return (
                <div key={memory.id} className={`${styles.masonryItem} ${styles.photoItem}`} data-memory-id={memory.id}>
                  <div
                    className={`${styles.photoCard}${responseHeader ? ` ${styles.responseCard}` : ''}`}
                    onClick={() => handleCardClick(memory)}
                    role="button"
                    tabIndex={0}
                  >
                    {responseHeader}
                    <div className={styles.photoImageWrap} style={photoAspectStyle}>
                      {photoUrl ? (
                        <img
                          className={styles.photoImage}
                          src={photoUrl}
                          alt={memory.title || 'Photo'}
                          fetchpriority={isFirstPhoto ? 'high' : undefined}
                          loading={isFirstPhoto ? 'eager' : 'lazy'}
                          onLoad={handleImageLoad}
                          onError={(e) => {
                            // D-2 fallback: feed variant not ready, use original
                            if (fallbackUrl && e.target.src !== fallbackUrl) {
                              e.target.src = fallbackUrl;
                            }
                          }}
                        />
                      ) : memory.blurHash ? (
                        <BlurHashCanvas hash={memory.blurHash} width={blurWidth} height={blurHeight} />
                      ) : (
                        <div className={styles.photoSkeleton}>
                          <div className={styles.photoSkeletonShimmer} />
                        </div>
                      )}

                      {memory.creatorType !== 'contributor' && (
                      <div className={`${styles.cardOverlay} ${memory.isFavorite ? styles.cardOverlayLiked : ''}`}>
                        <button
                          className={`${styles.cardOverlayBtn} ${memory.isFavorite ? styles.cardOverlayBtnLiked : ''}`}
                          onClick={(e) => { e.stopPropagation(); handleFavorite(memory); }}
                          aria-label={memory.isFavorite ? 'Remove from favorites' : 'Add to favorites'}
                        >
                          <HeartIcon filled={memory.isFavorite} />
                        </button>
                        <button
                          className={`${styles.cardOverlayBtn} ${styles.cardOverlayEdit} ${memory.isFavorite ? styles.cardOverlayEditWhenLiked : ''}`}
                          onClick={(e) => { e.stopPropagation(); handleEdit(memory); }}
                          aria-label="Edit memory"
                        >
                          <EditIcon />
                        </button>
                      </div>
                      )}
                    </div>

                    <div className={styles.photoContent}>
                      {memory.title && (
                        <p className={styles.photoTitle}>{memory.title}</p>
                      )}
                      {!memory.title && <p className={styles.photoLabel}>Photo</p>}
                    </div>

                    <div className={`${styles.cardFooter} ${styles.photoCardFooter}`}>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                        {responseDay || <span className={styles.cardDate}>{formatCardAttribution(memory)}</span>}
                      </span>
                      <span className={styles.cardPrivacy} style={responseChip ? { display: 'inline-flex', alignItems: 'center', gap: 6 } : undefined}>
                        {responseChip}
                        <PrivacyIcon isPrivate={memory.isPrivate} />
                      </span>
                    </div>
                  </div>
                  {renderPendingAffordance(memory)}
                  {memberTagsEnabled && <FeedTags entry={memory} onOpen={() => handleCardClick(memory)} />}
                </div>
              );
            }

            /* ── Video card ── */
            if (category === 'video') {
              return (
                <div key={memory.id} className={styles.masonryItem} data-memory-id={memory.id}>
                  <VideoCard
                    memory={memory}
                    onFavorite={handleFavorite}
                    onEdit={handleEdit}
                    onClick={handleCardClick}
                    redesign={feedRedesignEnabled}
                    spaceIsGroup={spaceIsGroup}
                    headerSlot={responseHeader}
                    footerSlot={responseDay}
                    footerEndSlot={responseChip}
                  />
                  {renderPendingAffordance(memory)}
                  {memberTagsEnabled && <FeedTags entry={memory} onOpen={() => handleCardClick(memory)} />}
                </div>
              );
            }

            /* ── Text card ── */
            return (
              <div key={memory.id} className={styles.masonryItem} data-memory-id={memory.id}>
                <div
                  className={`${styles.textCard}${responseHeader ? ` ${styles.responseCard}` : ''}`}
                  onClick={() => handleCardClick(memory)}
                  role="button"
                  tabIndex={0}
                >
                  {memory.creatorType !== 'contributor' && (
                  <div className={`${styles.cardOverlay} ${memory.isFavorite ? styles.cardOverlayLiked : ''}`}>
                    <button
                      className={`${styles.cardOverlayBtn} ${memory.isFavorite ? styles.cardOverlayBtnLiked : ''}`}
                      onClick={(e) => { e.stopPropagation(); handleFavorite(memory); }}
                      aria-label={memory.isFavorite ? 'Remove from favorites' : 'Add to favorites'}
                    >
                      <HeartIcon filled={memory.isFavorite} />
                    </button>
                    <button
                      className={`${styles.cardOverlayBtn} ${styles.cardOverlayEdit} ${memory.isFavorite ? styles.cardOverlayEditWhenLiked : ''}`}
                      onClick={(e) => { e.stopPropagation(); handleEdit(memory); }}
                      aria-label="Edit memory"
                    >
                      <EditIcon />
                    </button>
                  </div>
                  )}

                  {responseHeader}
                  {!responseHeader && <p className={styles.textLabel}>TEXT</p>}   {/* v2.47: the response header's chip already says it */}

                  <div className={styles.textContent}>
                    {memory.title && (
                      <p className={styles.textTitle}>{memory.title}</p>
                    )}
                    {memory.note && (
                      <p className={styles.textNote}>{memory.note}</p>
                    )}
                  </div>

                  <div className={styles.cardFooter}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                      {responseDay || <span className={styles.cardDate}>{formatCardAttribution(memory)}</span>}
                    </span>
                    <span className={styles.cardPrivacy} style={responseChip ? { display: 'inline-flex', alignItems: 'center', gap: 6 } : undefined}>
                      {responseChip}
                      <PrivacyIcon isPrivate={memory.isPrivate} />
                    </span>
                  </div>
                </div>
                {renderPendingAffordance(memory)}
                {memberTagsEnabled && <FeedTags entry={memory} onOpen={() => handleCardClick(memory)} />}
              </div>
            );
          })}
        </div>
        );
      })()}

      </div>{/* end feedPad */}
    </div>
  );
}
